import React, { useEffect } from 'react';
import img1 from '../../assets/img/fafa.jpg'
import img2 from '../../assets/img/e-commerce.jpg'
import img3 from '../../assets/img/manabilt.jpg'
// import img4 from '../../assets/img/cornelder.png'
import img5 from '../../assets/img/list.png'
import img6 from '../../assets/img/movie-info.png'
import img7 from '../../assets/img/rad-drive.png'

import AOS from 'aos'
import 'aos/dist/aos.css';

import './projects.css'

const projects = [
  { id: 'rad-drive', image: img7, alt: 'RAD Drive', name: 'RAD Drive', hrefGitHub: 'https://github.com/Miargy6/RAD-Drive', className: 'btn', hrefLiveDemo: 'https://raddrive-15c2b.web.app/', delay: "650" },
  { id: 'movie-info', image: img6, alt: 'Movie info', name: 'Movie Info', hrefGitHub: 'https://github.com/Miargy6/movie-info', className: 'btn', hrefLiveDemo: 'https://movie-inf.netlify.app', delay: "650" },
  { id: 'manabilt', image: img3, alt: 'ManaBilt', name: 'ManaBilt', hrefGitHub: '', className: 'btn btn-disable', hrefLiveDemo: 'https://www.manabilt.com/', delay: "800" },
  { id: 'fafa', image: img1, alt: 'Fafa website', name: 'Fafa LifeStyle', hrefGitHub: 'https://github.com/Miargy6/fafa_website', className: 'btn', hrefLiveDemo: 'https://fafa-healthier.netlify.app', delay: "650" },
  // { id: 'cornelder', image: img4, alt: 'Cornelder Photo Platform', name: 'Cornelder Photo Platform', className: 'btn', hrefGitHub: '#', hrefLiveDemo: '#' , delay:"650"},
  { id: 'list', image: img5, alt: 'Shop List', name: 'List Js', hrefGitHub: '', className: 'btn btn-disable', hrefLiveDemo: 'https://groceryslist.netlify.app', delay: "500" },
  { id: 'atozshop', image: img2, alt: 'A to Z shop e-commerce', name: 'A-to-Z Shop', hrefGitHub: 'https://github.com/Miargy6/E-commerce-AtoZShop', className: 'btn', hrefLiveDemo: 'https://atozshop.netlify.app', delay: "500" },
]

const Projects = () => {
  useEffect(() => {
    AOS.init({ duration: 800 })
  }, []);
  return (
    <section id='projects'>
      <h4 data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="100">My Work</h4>
      <h2 data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="200">Projects</h2>
      <div className="container project-container" data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="300">
        {projects.map((project) => (
          <article className='project-item' id={project.id} key={project.id} data-aos="fade-right" data-aos-delay={project.delay}>
            <a href={project.hrefLiveDemo} target='_blank' rel="noopener noreferrer">
              <div className="project-item-img">
                <img src={project.image} alt={project.alt} />
                {console.log(project.image)}
              </div>
            </a>
            <h3>{project.name}</h3>
            <div className="project-item-btn">
              <a href={project.hrefGitHub} className={project.className} target='_blank' rel="noopener noreferrer">GitHub</a>
              <a href={project.hrefLiveDemo} className='btn btn-primary' target='_blank' rel="noopener noreferrer">Live Demo</a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Projects;
